import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
// The "blur" effect leaves a blurred placeholder background behind the
// image - on thumbnails that don't exactly fill their box (most creator
// video/show cards) this showed up as a permanent hazy "backdrop" around
// the image. "opacity" just fades the real image in with no background
// layer, so there's nothing left to show through.
import "react-lazy-load-image-component/src/effects/opacity.css";
import logoImage from "../../../Assets/Images/ayozat_lazy.png";

function LazyLoading({
  imgSrc,
  imgAlt,
  imgHeight,
  imgWidth,
  classname,
  className,
  style,
  wrapperClassName,
  wrapperProps,
}: any) {
  return (
    <LazyLoadImage
      effect="opacity"
      src={imgSrc}
      alt={imgAlt && imgAlt}
      height={imgHeight && imgHeight}
      width={imgWidth && imgWidth}
      placeholderSrc={logoImage}
      // accept both `className` and the legacy `classname` prop
      className={className || classname}
      style={style && style}
      wrapperClassName={wrapperClassName}
      wrapperProps={wrapperProps}
    />
  );
}

export default LazyLoading;